module.exports = __webpack_public_path__ + "img/1.894f1283.png";